import React from "react";

const ServicesLinkCarousel = () => {
  return (
    <>
      <section className="overflow-hidden pt-0 custom-mt-10 position-relative z-index-1 mt-0">
        <div className="container-fluid p-0">
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div
                className="owl-carousel owl-center owl-loaded owl-drag"
                data-items="4"
                data-md-items="2"
                data-sm-items="2"
                data-center="true"
                data-dots="false"
                data-nav="true"
                data-autoplay="true"
              >
                <div className="owl-stage-outer">
                  <div
                    className="owl-stage"
                    style={{
                      transition: "all 1s ease 0s",
                      width: "5318px",
                      transform: "translate3d(-949px, 0px, 0px)",
                    }}
                  >
                    <div
                      className="owl-item cloned"
                      style={{ width: "379.8px" }}
                    >
                      <div className="item">
                        <div className="cases-item">
                          <div className="cases-images">
                            <img
                              className="img-fluid"
                              src="../images/services/links-section/seo.png"
                              alt="Search Engine Optimization"
                            />
                          </div>
                          <div className="cases-description">
                            <h5>
                              <a href="/services/search-engine-optimization">
                                Search Engine Optimization 1
                              </a>
                            </h5>
                            {/* <span>Digital</span> */}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="owl-item cloned"
                      style={{ width: "379.8px" }}
                    >
                      <div className="item">
                        <div className="cases-item">
                          <div className="cases-images">
                            <img
                              className="img-fluid"
                              src="../images/services/links-section/smo.png"
                              alt="Social Media Optiization"
                            />
                          </div>
                          <div className="cases-description">
                            <h5>
                              <a href="/services/social-media-optimization">
                                Social Media Optimization
                              </a>
                            </h5>
                            {/* <span>Digital</span> */}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="owl-item cloned"
                      style={{ width: "379.8px" }}
                    >
                      <div className="item">
                        <div className="cases-item">
                          <div className="cases-images">
                            <img
                              className="img-fluid"
                              src="../images/services/links-section/contentMarketing.png"
                              alt="Content Marketing"
                            />
                          </div>
                          <div className="cases-description">
                            <h5>
                              <a href="/services/content-marketing">
                                Content Marketing
                              </a>
                            </h5>
                            {/* <span>Digital</span> */}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="owl-item cloned active"
                      style={{ width: "379.8px" }}
                    >
                      <div className="item">
                        <div className="cases-item">
                          <div className="cases-images">
                            <img
                              className="img-fluid"
                              src="../images/services/links-section/emailMarketing.png"
                              alt=" Email Marketing"
                            />
                          </div>
                          <div className="cases-description">
                            <h5>
                              <a href="/services/email-marketing">
                                Email Marketing
                              </a>
                            </h5>
                            {/* <span>Digital</span> */}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="owl-item active center"
                      style={{ width: "379.8px" }}
                    >
                      <div className="item">
                        <div className="cases-item">
                          <div className="cases-images">
                            <img
                              className="img-fluid"
                              src="../images/services/links-section/leadGeneration.png"
                              alt=""
                            />
                          </div>
                          <div className="cases-description">
                            <h5>
                              <a href="/services/lead-generation">
                                Lead Generation
                              </a>
                            </h5>
                            {/* <span>Digital</span> */}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="owl-item active"
                      style={{ width: "379.8px" }}
                    >
                      <div className="item">
                        <div className="cases-item">
                          <div className="cases-images">
                            <img
                              className="img-fluid"
                              src="../images/services/links-section/programmaticAdvertising.png"
                              alt=""
                            />
                          </div>
                          <div className="cases-description">
                            <h5>
                              <a href="/services/programmatic-advertising">
                                Programmatic Advertising
                              </a>
                            </h5>
                            {/* <span>Digital</span> */}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="owl-item active"
                      style={{ width: "379.8px" }}
                    >
                      <div className="item">
                        <div className="cases-item">
                          <div className="cases-images">
                            <img
                              className="img-fluid"
                              src="../images/services/links-section/ppc.png"
                              alt="Pay Per Click"
                            />
                          </div>
                          <div className="cases-description">
                            <h5>
                              <a href="/services/ppc">Pay Per Click</a>
                            </h5>
                            {/* <span>Digital</span> */}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="owl-item" style={{ width: "379.8px" }}>
                      <div className="item">
                        <div className="cases-item">
                          <div className="cases-images">
                            <img
                              className="img-fluid"
                              src="../images/services/links-section/seo.png"
                              alt="Search Engine Optimization"
                            />
                          </div>
                          <div className="cases-description">
                            <h5>
                              <a href="/services/search-engine-optimization">
                                Search Engine Optimization
                              </a>
                            </h5>
                            {/* <span>Digital</span> */}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="owl-item" style={{ width: "379.8px" }}>
                      <div className="item">
                        <div className="cases-item">
                          <div className="cases-images">
                            <img
                              className="img-fluid"
                              src="../images/services/links-section/smo.png"
                              alt="Social Media Optimization"
                            />
                          </div>
                          <div className="cases-description">
                            <h5>
                              <a href="/services/social-media-optimization">
                                Social Media Optimization
                              </a>
                            </h5>
                            {/* <span>Digital</span> */}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="owl-item" style={{ width: "379.8px" }}>
                      <div className="item">
                        <div className="cases-item">
                          <div className="cases-images">
                            <img
                              className="img-fluid"
                              src="../images/services/links-section/emailMarketing.png"
                              alt="Email Marketing"
                            />
                          </div>
                          <div className="cases-description">
                            <h5>
                              <a href="/services/email-marketing">
                                Email Marketing
                              </a>
                            </h5>
                            {/* <span>Digital</span> */}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="owl-item cloned"
                      style={{ width: "379.8px" }}
                    >
                      <div className="item">
                        <div className="cases-item">
                          <div className="cases-images">
                            <img
                              className="img-fluid"
                              src="../images/services/links-section/programmaticAdvertising.png"
                              alt="Programmatic Advertising"
                            />
                          </div>
                          <div className="cases-description">
                            <h5>
                              <a href="/services/programmatic-advertising">
                                Programmatic Advertising
                              </a>
                            </h5>
                            {/* <span>Digital</span> */}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="owl-item cloned"
                      style={{ width: "379.8px" }}
                    >
                      <div className="item">
                        <div className="cases-item">
                          <div className="cases-images">
                            <img
                              className="img-fluid"
                              src="../images/services/links-section/leadGeneration.png"
                              alt="Lead Generation"
                            />
                          </div>
                          <div className="cases-description">
                            <h5>
                              <a href="/services/lead-generation">
                                Lead Generation
                              </a>
                            </h5>
                            {/* <span>Digital</span> */}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="owl-item cloned"
                      style={{ width: "379.8px" }}
                    >
                      <div className="item">
                        <div className="cases-item">
                          <div className="cases-images">
                            <img
                              className="img-fluid"
                              src="../images/services/links-section/seo.png"
                              alt="Search Engine Optimization"
                            />
                          </div>
                          <div className="cases-description">
                            <h5>
                              <a href="/services/search-engine-optimization">
                                Search Engine Optimization
                              </a>
                            </h5>
                            {/* <span>Digital</span> */}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="owl-item cloned"
                      style={{ width: "379.8px" }}
                    >
                      <div className="item">
                        <div className="cases-item">
                          <div className="cases-images">
                            <img
                              className="img-fluid"
                              src="../images/services/links-section/smo.png"
                              alt="Social Media Optimization"
                            />
                          </div>
                          <div className="cases-description">
                            <h5>
                              <a href="/services/social-media-optimization">
                                Social Media Optimization
                              </a>
                            </h5>
                            {/* <span>Digital</span> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="owl-nav">
                  <button
                    type="button"
                    role="presentation"
                    className="owl-prev"
                  >
                    <span className="fas fa-long-arrow-alt-left">
                      <span></span>
                    </span>
                  </button>
                  <button
                    type="button"
                    role="presentation"
                    className="owl-next"
                  >
                    <span className="fas fa-long-arrow-alt-right"></span>
                  </button>
                </div>
                <div className="owl-dots disabled"></div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ServicesLinkCarousel;
